import styled from 'styled-components';
import { Box, Button, Heading, Inline, Modal } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';

const StyledHeading = styled(Heading)`
    ${mediaQuery.only('small')} {
        text-align: center;
        width: 50%;
    }
`;

export type ConfirmRemoveModalProps = {
    onConfirm: () => void;
    onCancel: () => void;
    visible: boolean;
};

export default function ConfirmRemoveModal({
    onConfirm,
    onCancel,
    visible,
}: ConfirmRemoveModalProps) {
    return (
        <Modal aria-label="Modal" onClose={onCancel} visible={visible}>
            <Box display="flex" justifyContent="center" paddingTop="0.25bu" paddingBottom="1.5bu">
                <StyledHeading accessibilityLevel={3} appearanceLevel={5}>
                    {__placeholder('Remove design from shortlist?')}
                </StyledHeading>
            </Box>
            <Box display="flex" justifyContent="center">
                <Inline space="0.75bu">
                    <Button appearance="secondary" onClick={onCancel}>
                        {__placeholder('Cancel')}
                    </Button>
                    <Button onClick={onConfirm}>{__placeholder('Remove')}</Button>
                </Inline>
            </Box>
        </Modal>
    );
}
